<template>
    <div class="row m-0">
        <div class="col-12">
            <div class="row headers text-dark text-center py-3">
            <h2 class="h4 m-0 mx-auto"> {{ $t("project") }} </h2>
            </div>
            <div class="row">
                <ul class="nav nav-tabs nav-pills lined flex-sm-row text-center w-100 mt-2 mb-3 p-0" id="pills-tab"
                    role="tablist">
                    <li class="nav-item flex-sm-fill" role="presentation">
                        <a class="nav-link text-uppercase font-weight-bold rounded-0 active" id="pills-project-tab"
                           data-toggle="pill" data-target="#pills-project" type="button" role="tab"
                           aria-controls="pills-project" aria-selected="true">
                            {{ $t("project") }}
                        </a>
                    </li>
                    <li class="nav-item flex-sm-fill" role="presentation">
                        <a class="nav-link text-uppercase font-weight-bold rounded-0" id="pills-courses-tab"
                           data-toggle="pill" data-target="#pills-courses" type="button" role="tab"
                           aria-controls="pills-courses" aria-selected="false">
                            {{ $t("courses") }}
                        </a>
                    </li>
                    <li class="nav-item flex-sm-fill" role="presentation">
                        <a class="nav-link text-uppercase font-weight-bold rounded-0" id="pills-blog-tab"
                           data-toggle="pill" data-target="#pills-blog" type="button" role="tab"
                           aria-controls="pills-blog" aria-selected="false">
                            {{ $t("blog") }}
                        </a>
                    </li>
                </ul>
                <div class="tab-content sections py-0 px-3" id="pills-tabContent">
                    <div class="tab-pane fade show active pb-3" id="pills-project" role="tabpanel"
                         aria-labelledby="pills-project-tab">
                        <div class="row">
                            <div class="col-sm-6 col-xl-4 mb-3 px-2"
                                 v-for="project in initialProjects"
                                 :key="project.title">
                                <div class="project-card p-3 shadow-sm h-100 rounded d-flex flex-column">
                                    <div class="d-flex align-items-center" style="gap: 5px">
                                        <img v-if="project.logo"
                                             :src="project.logo"
                                             class="project-logo"
                                             :alt="project.title + ' logo'">
                                        <h5 class="mb-0">{{ project.title }}</h5>
                                    </div>
                                    <p class="small my-2">{{ project.description }}</p>
                                    <div class="mb-2">
                                        <span v-for="tag in project.tags" :key="tag"
                                              class="badge badge-light border mr-1">
                                            {{ tag }}
                                        </span>
                                    </div>
                                    <div class="blog-card-meta mt-auto">
                                        <a v-if="project.demo"
                                           :href="project.demo"
                                           target="_blank"
                                           class="blog-card-link">
                                            <i class="bx bx-link-external"></i> {{ $t('live_demo') }}
                                        </a>
                                        <a v-if="project.github"
                                           :href="project.github"
                                           target="_blank"
                                           class="blog-card-link">
                                            <i class="bx bxl-github"></i> {{ $t('github') }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center" v-if="extraProjects.length">
                            <vs-button class="d-inline" transparent active color="#22333B"
                                       data-toggle="collapse" data-target="#collapseProjects"
                                       aria-expanded="false" aria-controls="collapseProjects">
                                {{ $t("more") }}
                            </vs-button>
                        </div>
                        <div class="collapse" id="collapseProjects">
                            <div class="row mt-3">
                                <div class="col-sm-6 col-xl-4 mb-3 px-2"
                                     v-for="project in extraProjects"
                                     :key="project.title">
                                    <div class="project-card p-3 shadow-sm h-100 rounded d-flex flex-column">
                                        <div class="d-flex align-items-center" style="gap: 5px">
                                            <img v-if="project.logo"
                                                 :src="project.logo"
                                                 class="project-logo"
                                                 :alt="project.title + ' logo'">
                                            <h5 class="mb-0">{{ project.title }}</h5>
                                        </div>
                                        <p class="small my-2">{{ project.description }}</p>
                                        <div class="mb-2">
                                            <span v-for="tag in project.tags" :key="tag"
                                                  class="badge badge-light border mr-1">
                                                {{ tag }}
                                            </span>
                                        </div>
                                        <div class="blog-card-meta mt-auto">
                                            <a v-if="project.demo"
                                               :href="project.demo"
                                               target="_blank"
                                               class="blog-card-link">
                                                <i class="bx bx-link-external"></i> {{ $t('live_demo') }}
                                            </a>
                                            <a v-if="project.github"
                                               :href="project.github"
                                               target="_blank"
                                               class="blog-card-link">
                                                <i class="bx bxl-github"></i> {{ $t('github') }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-courses" role="tabpanel" aria-labelledby="pills-courses-tab">
                        <div class="course-card w-100 p-3 mb-3">
                            <div class="media">
                                <figure class="figure m-0">
                                    <img src="@/assets/images/courses/db.png" class="courses-images rounded" alt="db">
                                    <figcaption class="figure-caption text-center courses-caption">
                                        <vs-avatar-group max="3">
                                            <vs-avatar>
                                                <img src="@/assets/images/courses/people/abolfazl.jpg" alt="abolfazl">
                                            </vs-avatar>
                                            <vs-avatar>
                                                <img src="@/assets/images/courses/people/nima.jpg" alt="nima">
                                            </vs-avatar>
                                            <vs-avatar>
                                                <i class='bx bx-user'></i>
                                            </vs-avatar>
                                            <vs-avatar>
                                                <i class='bx bx-user'></i>
                                            </vs-avatar>
                                            <vs-avatar>
                                                <i class='bx bx-user'></i>
                                            </vs-avatar>
                                        </vs-avatar-group>
                                    </figcaption>
                                </figure>
                                <div class="media-body ml-2">
                                    <span class="d-block"> {{ $t("db_course") }} </span>
                                    <span class="d-block"> {{ $t("db_teachers") }} </span>
                                </div>
                            </div>
                            <div class="blog-card-meta">
                                <span class="blog-card-date">
                                    <i class='bx bx-buildings'></i>
                                    {{ $t("quera") }}
                                </span>
                                <a href="https://quera.org/college/landpage/8939/database"
                                   target="_blank"
                                   class="blog-card-link">
                                    {{ $t("register") }}
                                    <i class='bx bx-right-arrow-alt'></i>
                                </a>
                            </div>
                        </div>
                        <div class="course-card w-100 p-3 mb-3">
                            <div class="media">
                                <figure class="figure m-0">
                                    <img src="@/assets/images/courses/linux.png" class="courses-images rounded"
                                         alt="linux">
                                    <figcaption class="figure-caption text-center courses-caption">
                                        <vs-avatar-group max="3">
                                            <vs-avatar>
                                                <img src="@/assets/images/courses/people/abolfazl.jpg" alt="abolfazl">
                                            </vs-avatar>
                                            <vs-avatar>
                                                <img src="@/assets/images/courses/people/salib.jpg" alt="salib">
                                            </vs-avatar>
                                            <vs-avatar>
                                                <i class='bx bx-user'></i>
                                            </vs-avatar>
                                            <vs-avatar>
                                                <i class='bx bx-user'></i>
                                            </vs-avatar>
                                            <vs-avatar>
                                                <i class='bx bx-user'></i>
                                            </vs-avatar>
                                            <vs-avatar>
                                                <i class='bx bx-user'></i>
                                            </vs-avatar>
                                        </vs-avatar-group>
                                    </figcaption>
                                </figure>
                                <div class="media-body ml-2">
                                    <span class="d-block"> {{ $t("linux_course") }} </span>
                                    <span class="d-block"> {{ $t("linux_teachers") }} </span>
                                </div>
                            </div>
                            <div class="blog-card-meta">
                                <span class="blog-card-date">
                                    <i class='bx bx-buildings'></i>
                                    {{ $t("quera") }}
                                </span>
                                <a href="https://quera.org/college/landpage/8903/linux"
                                   target="_blank"
                                   class="blog-card-link">
                                    {{ $t("register") }}
                                    <i class='bx bx-right-arrow-alt'></i>
                                </a>
                            </div>
                        </div>
                        <div class="course-card w-100 p-3 mb-3">
                            <div class="media">
                                <figure class="figure m-0">
                                    <img src="@/assets/images/courses/laravel.png" class="courses-images rounded"
                                         alt="laravel">
                                    <figcaption class="figure-caption text-center courses-caption">
                                        <vs-avatar-group max="3">
                                            <vs-avatar>
                                                <img src="@/assets/images/courses/people/abolfazl.jpg" alt="abolfazl">
                                            </vs-avatar>
                                            <vs-avatar>
                                                <img src="@/assets/images/courses/people/nima.jpg" alt="nima">
                                            </vs-avatar>
                                            <vs-avatar>
                                                <i class='bx bx-user'></i>
                                            </vs-avatar>
                                            <vs-avatar>
                                                <i class='bx bx-user'></i>
                                            </vs-avatar>
                                            <vs-avatar>
                                                <i class='bx bx-user'></i>
                                            </vs-avatar>
                                            <vs-avatar>
                                                <i class='bx bx-user'></i>
                                            </vs-avatar>
                                            <vs-avatar>
                                                <i class='bx bx-user'></i>
                                            </vs-avatar>
                                        </vs-avatar-group>
                                    </figcaption>
                                </figure>
                                <div class="media-body ml-2">
                                    <span class="d-block"> {{ $t("laravel_course") }} </span>
                                    <span class="d-block"> {{ $t("laravel_teachers") }} </span>
                                </div>
                            </div>
                            <div class="blog-card-meta">
                                <span class="blog-card-date">
                                    <i class='bx bx-buildings'></i>
                                    {{ $t("quera") }}
                                </span>
                                <a href="https://quera.org/college/landpage/7615/laravel"
                                   target="_blank"
                                   class="blog-card-link">
                                    {{ $t("register") }}
                                    <i class='bx bx-right-arrow-alt'></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade posts-div pb-3" id="pills-blog" role="tabpanel"
                         aria-labelledby="pills-blog-tab" ref="blog">
                        <div class="blog-carousel-wrapper">
                            <button class="blog-nav blog-nav-prev" type="button"
                                    @click="scrollCarousel(-1)"
                                    aria-label="Previous">
                                <i class='bx bx-chevron-left'></i>
                            </button>
                            <div class="blog-carousel" ref="carousel">
                                <div class="blog-carousel-item"
                                     v-for="article in articles"
                                     :key="article.node.slug">
                                    <article class="blog-card h-100">
                                        <a v-if="article.node.coverImage.url" :href="article.node.link" target="_blank">
                                            <div class="blog-card-image">
                                                <img :src="article.node.coverImage.url" :alt="article.node.title" loading="lazy">
                                            </div>
                                        </a>
                                        <div class="blog-card-body p-3">
                                            <a :href="article.node.link" target="_blank">
                                                <h5 class="blog-card-title">{{ article.node.title }}</h5>
                                            </a>
                                            <p class="blog-card-brief">{{ article.node.brief }}</p>
                                            <div class="blog-card-meta">
                                                <span class="blog-card-date">
                                                    <i class='bx bx-calendar'></i>
                                                    {{ moment(article.node.publishedAt).format('MMM D, YYYY') }}
                                                </span>
                                                <a :href="article.node.link" target="_blank">
                                                    <span class="blog-card-link">
                                                        {{ $t("read_more") }}
                                                        <i class='bx bx-right-arrow-alt'></i>
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </div>
                            <button class="blog-nav blog-nav-next" type="button"
                                    @click="scrollCarousel(1)"
                                    aria-label="Next">
                                <i class='bx bx-chevron-right'></i>
                            </button>
                        </div>
                        <div class="sections pt-2 pb-0 px-3 w-40 text-center">
                            <vs-button class="d-inline" href="https://blog.abolfazlmohajeri.ir" blank transparent active
                                       color="#22333B">
                                {{ $t("visit_blog") }}
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment/moment";

const INITIAL_PROJECT_COUNT = 3;
const RSS_URL = 'https://blog.abolfazlmohajeri.ir/rss.xml';
const FEED_URL = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(RSS_URL)}`;

export default {
    name: "Project",
    data() {
        return {
            articles: null
        }
    },
    mounted() {
        this.fetchArticles();
    },
    computed: {
        projects() {
            return this.$t('projects');
        },
        initialProjects() {
            return this.projects.slice(0, INITIAL_PROJECT_COUNT);
        },
        extraProjects() {
            return this.projects.slice(INITIAL_PROJECT_COUNT);
        }
    },
    methods: {
        moment(date) {
            return moment(date);
        },
        fetchArticles() {
            const loading = this.$vs.loading({
                target: this.$refs.blog,
                type: 'corners',
                color: 'dark'
            });
            fetch(FEED_URL)
                .then(res => {
                    if (!res.ok) throw new Error(`HTTP ${res.status}`);
                    return res.json();
                })
                .then(data => {
                    if (data.status !== 'ok') throw new Error(data.message || 'Feed error');
                    const items = (data.items || []).slice(0, 5);
                    this.articles = items.map(item => ({
                        node: {
                            slug: this.slugFromLink(item.link),
                            title: item.title || '',
                            brief: this.stripHtml(item.description || item.content || ''),
                            coverImage: { url: (item.enclosure && item.enclosure.link) || item.thumbnail || '' },
                            publishedAt: item.pubDate || '',
                            link: item.link || ''
                        }
                    }));
                })
                .catch(err => console.error('Feed fetch failed:', err))
                .finally(() => {
                    try { loading.close(); } catch (e) { /* vuesax can throw on hidden tab */ }
                });
        },
        stripHtml(html) {
            const tmp = document.createElement('div');
            tmp.innerHTML = html || '';
            return (tmp.textContent || tmp.innerText || '').trim();
        },
        slugFromLink(link) {
            const parts = (link || '').split('?')[0].split('/').filter(Boolean);
            return parts[parts.length - 1] || (link || '');
        },
        scrollCarousel(direction) {
            const carousel = this.$refs.carousel;
            if (!carousel) return;
            const firstItem = carousel.querySelector('.blog-carousel-item');
            const step = firstItem ? firstItem.offsetWidth : 300;
            carousel.scrollBy({ left: step * direction, behavior: 'smooth' });
        }
    }
}
</script>

<style>
.lined li {
    width: 33% !important;
}

.lined .nav-link {
    color: var(--tab-inactive);
    border: none;
    border-bottom: 3px solid transparent;
}

.lined .nav-link:hover {
    border: none;
    color: var(--tab-active);
    border-bottom: 3px solid transparent;
}

.lined .nav-link.active {
    background: none;
    color: var(--tab-active);
    border-color: var(--tab-active);
    padding-bottom: 12px !important;
}

.posts-div {
    font-family: MontserratMedium;
    direction: ltr;
    text-align: left;
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}

.courses-caption {
    transform: translateY(-20px);
}

.extra-small {
    font-size: 0.7em;
    font-weight: 400;
}
</style>

<style scoped>
.project-card {
    background: linear-gradient(180deg, var(--card-grad-start) 0%, var(--card-grad-end) 100%);
    border: 1px solid var(--border);
    border-radius: 12px !important;
    transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
    position: relative;
}

.project-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 15px var(--card-shadow);
    border-color: var(--border-strong);
}

.course-card {
    background: linear-gradient(180deg, var(--card-grad-start) 0%, var(--card-grad-end) 100%);
    border: 1px solid var(--border);
    border-radius: 12px;
    transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.course-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 15px var(--card-shadow);
    border-color: var(--border-strong);
}

.course-card .media {
    align-items: center;
    min-height: 130px;
}

.course-card .figure {
    flex-shrink: 0;
}

.course-card .courses-images {
    transition: transform 0.4s ease;
}

.course-card:hover .courses-images {
    transform: scale(1.03);
}

.course-card .media-body {
    transform: translateY(-20px);
}

.course-card .media-body a {
    color: var(--accent);
    font-weight: 500;
    transition: color 0.2s ease;
}

.course-card .media-body a:hover {
    color: var(--accent-hover);
}

.project-logo {
    width: 32px;
    height: 32px;
    object-fit: contain;
    border-radius: 6px;
}

.project-link {
    font-size: 14px;
    color: var(--accent);
    font-weight: 500;
}

.project-link i {
    font-size: 14px;
    vertical-align: middle;
    transform: translateY(-1px);
}

.blog-carousel-wrapper {
    position: relative;
    padding: 4px 0;
}

.blog-carousel {
    display: flex;
    gap: 16px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    padding: 4px 4px 14px;
    margin: 0 -4px;
    scrollbar-width: thin;
    scrollbar-color: var(--border-strong) transparent;
}

.blog-carousel::-webkit-scrollbar {
    height: 6px;
}

.blog-carousel::-webkit-scrollbar-thumb {
    background: var(--border-strong);
    border-radius: 3px;
}

.blog-carousel::-webkit-scrollbar-track {
    background: transparent;
}

.blog-carousel-item {
    flex: 0 0 100%;
    scroll-snap-align: start;
    min-width: 0;
}

@media (min-width: 576px) {
    .blog-carousel-item {
        flex: 0 0 calc(50% - 8px);
    }
}

@media (min-width: 1200px) {
    .blog-carousel-item {
        flex: 0 0 calc(33.333% - 11px);
    }
}

.blog-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 1px solid var(--border);
    background: var(--surface);
    color: var(--accent);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
    z-index: 2;
    padding: 0;
}

.blog-nav:hover {
    background: var(--brand-start);
    color: #ffffff;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
}

.blog-nav:active {
    transform: translateY(-50%) scale(0.95);
}

.blog-nav-prev {
    left: -8px;
}

.blog-nav-next {
    right: -8px;
}

@media (max-width: 575.98px) {
    .blog-nav {
        display: none;
    }
}

.blog-card {
    background: linear-gradient(180deg, var(--card-grad-start) 0%, var(--card-grad-end) 100%);
    border: 1px solid var(--border);
    border-radius: 12px;
    overflow: hidden;
    transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
    display: flex;
    flex-direction: column;
}

.blog-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 15px var(--card-shadow);
    border-color: var(--border-strong);
}

.blog-card:hover .blog-card-image img {
    transform: scale(1.05);
}

.blog-card:hover .blog-card-link {
    color: var(--accent-hover);
}

.blog-card:hover .blog-card-link i {
    transform: translateX(4px);
}

.blog-card-image {
    height: 160px;
    overflow: hidden;
    background: var(--image-bg);
}

.blog-card-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
}

.blog-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.blog-card-title {
    font-size: 15px;
    font-weight: 600;
    color: var(--accent);
    margin: 0 0 8px;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.blog-card-brief {
    font-size: 13px;
    color: var(--muted);
    margin: 0 0 12px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    flex: 1;
}

.blog-card-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: var(--muted);
    padding-top: 10px;
    border-top: 1px solid var(--border);
}

.blog-card-date {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.blog-card-date i {
    font-size: 14px;
}

.blog-card-link {
    color: var(--accent);
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    transition: color 0.2s ease;
}

.blog-card-link i {
    font-size: 14px;
    transition: transform 0.2s ease;
}
</style>
